import {
  GridViewAdvancedFilter,
  GridViews,
  WcgAdvancedFilter,
} from '@wcg/frontend-framework';
import { camelCase } from 'lodash';
import { GridView } from '../types';

export function gridViewsMapper(view: GridView): GridViews {
  return {
    advancedFilters: view.advanced_filters ?? {},
    columns: view.columns ?? {},
    default: view.default ?? false,
    gridType: view.grid_type,
    id: view.id!,
    name: view.name.toString(),
    pagination: view.pagination ?? 0,
    searchString: view.search_string || '',
    sorted: view.sorted ?? null,
  };
}

export function optimizedGridAdvancedFilters(
  advancedFilters: WcgAdvancedFilter,
): GridViewAdvancedFilter {
  return Object.entries(advancedFilters).reduce((acc, [key, value]) => {
    acc[key] = {
      key: value.columnKey,
      value: value.value,
    };
    return acc;
  }, {} as GridViewAdvancedFilter);
}

export function mapAdvancedFilterByGridView(
  advancedFilters: WcgAdvancedFilter,
  gridViewAdFilter: GridViewAdvancedFilter,
) {
  const _advancedFilters: WcgAdvancedFilter = { ...advancedFilters };

  for (const key of Object.keys(advancedFilters)) {
    const gridFilter = gridViewAdFilter[camelCase(key)];
    const originalValue = advancedFilters[key]?.value;

    const fallbackValue = Array.isArray(originalValue)
      ? []
      : typeof originalValue === 'string'
        ? ''
        : undefined;

    _advancedFilters[key] = {
      ...advancedFilters[key],
      value: gridFilter?.value ?? fallbackValue,
    };
  }

  return _advancedFilters;
}
